import { render, staticRenderFns } from "./horizontal-timeline.vue?vue&type=template&id=123a2322&scoped=true&"
import script from "./horizontal-timeline.vue?vue&type=script&lang=js&"
export * from "./horizontal-timeline.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-timeline.vue?vue&type=style&index=0&id=123a2322&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a2322",
  null
  
)

export default component.exports